export type Unknown<T> = {
    [P in keyof T]?: unknown
}

const REDIRECT_ERROR_CODE = "NEXT_REDIRECT"

export function isRedirectError(error: unknown) {
    if (typeof (error as { digest: unknown })?.digest !== "string") return false

    const [errorCode, type, destination, permanent] = (error as { digest: string }).digest.split(";", 4)

    return (
        errorCode === REDIRECT_ERROR_CODE &&
        (type === "replace" || type === "push") &&
        typeof destination === "string" &&
        (permanent === "true" || permanent === "false")
    )
}

// Checks if an error
export function isError(error: unknown): error is Error {
    return error instanceof Error
}

export function hasStatus(error: unknown): error is { status: number } {
    return "status" in (error as { status: unknown })
}
